import React, { useEffect, useState } from "react";
import { useApi } from "../../../context/ApiProvider";
import 'chart.js/auto';
import { Line } from 'react-chartjs-2';

function Statistics(props) {
    const [includeNonPaying, setIncludeNonPaying] = useState(false);
    const [isLoadingStats, setIsLoadingStats] = useState(true);
    const [stats, setStats] = useState(false);
    const [diagramDatasets, setDiagramDatasets] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [maxValues, setMaxValues] = useState(false);
    const Api = useApi();

    const URI = ``;
    /*Temp utv test:*/
    //const URI = `/clients/258/organisations/1638/statistics`


    useEffect(() => {

        setIsLoadingStats(true);
        loadStats();
    }, [includeNonPaying]);

    useEffect(() => {
        // Leta reda på maxvalues från datat
        const getMaxValues = () => {
          let prev = { lcs: 1, lcsself: 1, notes: 1, activity: 1, log: 1 };
          stats && stats.map((month, index) => {
            prev = {
              lcs: prev.lcs < month.lcs ? month.lcs : prev.lcs,
              lcsself: prev.lcsself < month.lcsself ? month.lcsself : prev.lcsself,
              notes: prev.notes < month.notes ? month.notes : prev.notes,
              activity: prev.activity < month.activity ? month.activity : prev.activity,
              log: prev.log < month.log ? month.log : prev.log,
            }
            return prev;
          });
          setMaxValues(prev);
        }
        getMaxValues();
        return () => { }
      }, [stats]);

      useEffect(() => {

        // Definiera dataset för diagrammet
        const diagramDatasets = [
          { id: 1, label: 'Rolfings', data: [], backgroundColor: "#5747AB", borderColor: "#5747AB" },
          { id: 2, label: 'Self rolfings', data: [], backgroundColor: "#FF9EB5", borderColor: "#FF9EB5" },
          { id: 3, label: 'Notes', data: [], backgroundColor: "#FFE061", borderColor: "#FFE061" },
          { id: 4, label: 'Activities', data: [], backgroundColor: "#36ABF0", borderColor: "#36ABF0" },
          { id: 5, label: 'Reflection logs', data: [], backgroundColor: "#82E5D6", borderColor: "#82E5D6" }
        ]
    
        // Fyll i dataset med data
        stats && stats.map((month, index) => {
          diagramDatasets[0].data[index] = parseFloat(month.lcs / maxValues.lcs) * 100 || 0;
          diagramDatasets[1].data[index] = parseFloat(month.lcsself / maxValues.lcsself) * 100 || 0;
          diagramDatasets[2].data[index] = parseFloat(month.notes / maxValues.notes) * 100 || 0;
          diagramDatasets[3].data[index] = parseFloat(month.activity / maxValues.activity) * 100 || 0;
          diagramDatasets[4].data[index] = parseFloat(month.log / maxValues.log) * 100 || 0;
    
        });
    
        // Sätt state
        setDiagramDatasets(diagramDatasets);
    
      }, [maxValues])

    function loadStats() {
        Api.get(`/rolf/statistics?${includeNonPaying ? 'paying=true' : ''}`).then(data => {
            setHasPermission(true);
            setStats(data);
        }).catch(error => {
            if(error.status == 403) {
                setHasPermission(false);
            }
            console.log(error);
        }).finally(() => {
            setIsLoadingStats(false);
        });
    }

    if(isLoadingStats) {
        return <div>Loading...</div>
    }

    if(!hasPermission) {
        return <div className="formControlError">Permission error: You do not have permission to view this.</div>
    }

  return (
    <div className='grid-container'>
        <section>
            <h4 className='spaceBetween '>
            <span>Statistics</span>
            <span>

                <input type='checkbox' checked={includeNonPaying} onChange={e => setIncludeNonPaying(e.target.checked)} />
                <span className="meta">Include non-paying customers</span>
            </span>
            </h4>
            <p>Here you find aggregated global usage statistics for all clients. As a default the statistics only includes paying clients, unless the "Include non-paying customers"-box is checked. The chart shows a relative usage trend where 100(%) represents the highest number of rolfings, reflection logs etc. The actual numbers is presented in the table below.</p>

            {diagramDatasets && <Line datasetIdKey='id' options={{ cubicInterpolationMode: "monotone" }}
                data={{
                    labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    datasets: diagramDatasets,
                }}
                style={{ marginBottom: "3rem" }} />
                }

                <table style={{ marginBottom: "3rem" }}>
                <thead>
                    <tr>
                    <th>Month</th >
                    <th>Rolfings</th >
                    <th>Self rolfings</th >
                    <th>Notes</th >
                    <th>Activities</th>
                    <th>Reflection logs</th>
                    </tr>
                </thead>
                <tbody>
                    {stats && stats.map((month, k) => {
                    return <tr key={k}>
                        <td>{month.name}</td>
                        <td>{month.lcs || '-'}</td>
                        <td>{month.lcsself || '-'}</td>
                        <td>{month.notes || '-'}</td>
                        <td>{month.activity || '-'}</td>
                        <td>{month.log || '-'}</td>
                    </tr>
                    })
                    }
                </tbody>
                </table>
                
        </section>
    </div>
  )
}

export default Statistics